import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn_icon, {
      icon: "$oss-edit",
      color: "green",
      elevation: "0",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEditCompanyClick())),
      size: "small",
      "data-cy": "ClientCompaniesEditCompanyBtn-Cta",
      disabled: _ctx.disabled
    }, null, 8, ["disabled"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.displayCompanyNotAvailableDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.displayCompanyNotAvailableDialog) = $event)),
      title: _ctx.companyNotAvailableDialog.title,
      "valid-title": _ctx.companyNotAvailableDialog.validText,
      onValid: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addAvailableCompany())),
      width: "60%",
      "data-cy": "ClientCompaniesEditCompanyBtn-OssDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.company.name) + " " + _toDisplayString(_ctx.companyNotAvailableDialog.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title", "valid-title"])
  ]))
}